<div class="page-title-area title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Gallery</h2>
                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Gallery</li>
                </ul>
            </div>
        </div>
    </div>
</div>